import React, { Component } from 'react';

import './style.scss';

export default class Invest extends Component {

    constructor(props){
        super(props);
    }

    render() {
        let { closePopup, modalData } = this.props;

        return (
          <div className="row align-items-center">
            <div className="col-md-5 bgcolour d-flex justify-content-start">
              <img src="/images/New/HDFC_LoadingScreen.gif" alt="HDFC_LoadingScreen" className="popvideo w-100" />
            </div>
            <div className="col-md-7">
              <div className="modal-body clearfix">
                <h3 className='my-2'>Welcome</h3>
                <span>Thanks for choosing us to be a part of your investment journey.</span>
                <div className="login-options">
                  <div className="new-investor">
                    {/*<h5>New Investor</h5>*/}
                      <a className="btn-primary" target="_blank"
                        href="https://investor-web.hdfcfund.com/new-investor" rel='noreferrer'>
                          Sign Up</a>
                  </div>
                  <div className="existing-investor">
                    {/*<h5>Existing Investor</h5>*/}
                      <a className="btn-primary" target="_blank"
                        href="https://investor-web.hdfcfund.com/instant-login" rel='noreferrer'>
                          Login</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
    }
}
